import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children, allowed }) {
    const { user, loading } = useAuth();
    if (loading) return <FullScreenLoader />;
    if (!user) return <Navigate to="/login" replace />;
    if (allowed && allowed.length && !allowed.includes(user.role) && user.role !== "super_admin") {
        return <Navigate to="/" replace />;
    }
    return children;
}

function FullScreenLoader() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-white">
            <div className="text-center">
                <div className="font-mono text-xs tracking-widest uppercase text-slate-400 mb-3">loading</div>
                <div className="w-10 h-10 border-t-2 border-slate-900 border-r-2 border-transparent animate-spin mx-auto" />
            </div>
        </div>
    );
}
